import React, { useState, useEffect } from "react";
import logo from "../../../images/PPKM_Head.png";
import { AppBar, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./mdheader.css";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen is mobile-sized
  console.log(window.location.pathname); //yields: "/js" (where snippets run)

  const [word, setWord] = useState("");

  useEffect(() => {
    // Determine the word based on the current pathname
    if (
      window.location.pathname.includes("individual_membership_application")
    ) {
      setWord("INDIVIDUAL MEMBERSHIP REGISTRATION");
    } else if (
      window.location.pathname.includes("corporate_membership_application")
    ) {
      setWord("CORPORATE MEMBERSHIP REGISTRATION");
    }
  }, [window.location.pathname]); // Dependency array to trigger useEffect when pathname changes

  return (
    <React.Fragment>
      <AppBar position="sticky" className="header">
        <Grid container alignItems="center" className="container-fluid">
          {/* Logo and Title Section */}
          <Grid
            xs={12}
            sm={6}
            md={3}
            className="part1"
            container
            alignItems="center"
          >
            <img src={logo} className="logo" alt="logo" />

            <Typography variant="h5" gutterBottom className="text-group">
              {word}
            </Typography>
          </Grid>
        </Grid>
      </AppBar>
    </React.Fragment>
  );
};

export default Header;
